export const apiUrl = __DEV__ ? __API__ : window.location.origin;

// apiUrl can have an ending slash, or not
// baseUrl will always return no ending slash
export const baseUrl = apiUrl.endsWith('/') ? apiUrl.substring(0, apiUrl.length - 1) : apiUrl;
